<div class="control"
     [class.control--empty]="hasNeitherValueNorFocusNorPrefix"
     [class.control--required]="isRequired"
     [class.control--invalid]="invalidAndDirty"
     [class.control--disabled]="isDisabled"
     [class.control--expanded]="expanded">
    <div class="control__box" (click)="onBoxClick()">
        <input #inputElement
               [attr.name]="formControlName ?? name"
               class="control__box__input"
               [type]="'text'"
               autocomplete="off"
               data-1p-ignore
               data-lpignore="true"
               data-form-type="other"
               (input)="onInputChange($any($event.target).value)"
               (focus)="onInputFocus()"
               (blur)="onInputBlur($event)"
               (click)="$event.stopPropagation()"
               [value]="searchText"
               [attr.disabled]="isDisabled ? '' : null">
    </div>
    <label class="control__label">{{ label }}</label>
    <div class="control__arrow" (click)="toggleExpand(); $event.stopPropagation()"></div>
    <div class="control__option-list">
        <div *ngFor="let item of filteredItems"
             (mousedown)="$event.preventDefault()"
             (click)="selectOption(item)"
             class="control__option-list__item"
             [class.control__option-list__item--disabled]="item.isDisabled"
             [class.control__option-list__item--selected]="selectedItem?.value === item.value">
            <div class="control__option-list__item__text" [innerHTML]="item.text"></div>
            <div class="control__option-list__item__sub-text" [innerHTML]="item.extraLabelText"></div>
        </div>
    </div>
</div>

